import { Theme, css } from '@emotion/react';
import { base } from 'omakase/Collapse/collapseCssDefs';

export const customBase = (theme: Theme) => [
  base(theme, false, false),
  css`
    margin-left: 0;
    margin-right: 0;
    border-radius: ${theme.borderRadius[200]};
    margin-bottom: ${theme.spacing(1.5)}px;

    ${theme.breakpoints.up(0)} {
      margin-left: 0;
      margin-right: 0;
      border-radius: ${theme.borderRadius[200]};
      margin-bottom: ${theme.spacing(1.5)}px;
    }

    /*
      For 'is-open' above, we change the border color and then add an outline to avoid
      using a thicker border and seeing movement of inner elements as the inner size changes
    */
    &.is-open {
      border-color: ${theme.colors.borderPrimaryDark};
      outline: solid 1px ${theme.colors.borderPrimaryDark};
    }
  `,
];

export const muiCardHeaderActionStylesOverride = (theme: Theme) => css`
  padding: ${theme.spacing(2)}px;

  > .MuiCardHeader-action {
    align-self: inherit;
    margin: 0;
  }
`;
